import { render } from "./ZoneStockageIndex.vue?vue&type=template&id=87f2edb0"
import script from "./ZoneStockageIndex.vue?vue&type=script&lang=js"
export * from "./ZoneStockageIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__